<template>
  <context-display :context="context">
    <template #simple>
      <p>{{datetimeTypeDisplay}}</p>
    </template>
    <template #workarea>
      <span v-html="displayDateRangeHtml"></span>
    </template>
  </context-display>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IDateMinMaxable} from "../../interfaces/propertyInterfaces";
  import DatetimeHelper from "../../helpers/datetimeHelper";
  import {DatetimeModeDisplay} from "../../models/datetimeMode";
  import ContextDisplay from "../layouts/contextDisplay.vue";
  import basePropertyDisplayMixin from "../../mixins/modelProperties/basePropertyDisplayMixin";

  export default Vue.extend({
    components: {
      ContextDisplay,
    },
    mixins: [
      basePropertyDisplayMixin,
    ],
    props: {
      model: {
        type: Object as () => IDateMinMaxable,
        required: true,
      },
    },
    data: function () {
      return {};
    },
    computed: {
      displayDateRangeHtml(): string {
        if (!this.model.canHaveDateMinMax) {
          if (this.showFallback) return this.cantFallback;
        } else if (this.model.hasDateMinOrMaxValue) {
          return this.dateRangeHTML;
        } else {
          if (this.showFallback) return this.fallback;
        }
      },
      dateRangeHTML(): string {
        let text = '';
        if (this.model.hasDateMin && this.model.hasDateMax) {
          text = `between ${this.minDate} and ${this.maxDate}`;
        } else if (this.model.hasDateMin) {
          text = `after ${this.minDate}`;
        } else if (this.model.hasDateMax) {
          text = `before ${this.maxDate}`;
        }
        return text;
      },
      minDate(): string {
        return this.parseDate(this.model.min_datetime);
      },
      maxDate(): string {
        return this.parseDate(this.model.max_datetime);
      },
      datetimeTypeDisplay(): string {
        return DatetimeModeDisplay[this.model.datetime_mode];
      },
    },
    methods: {
      parseDate(dateString: string): string {
        return DatetimeHelper.formatDate(
            DatetimeHelper.parseDate(dateString),
            DatetimeHelper.timezone,
            DatetimeHelper.displayFormat(this.model.datetime_mode),
        );
      },
    }
  });
</script>
